import React, { useEffect } from 'react';
import IvoriMethodTaraPage from '../../features/method/IvoriMethodTaraPage';

export default function IvoriMethodTaraRoute() {
  useEffect(() => {
    document.title = "The IVORI Method — Walton, Frederick & Hayes and Flower | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <IvoriMethodTaraPage />;
}